<!-- Services -->
<section id="services">
    <!-- Section Content -->
    <div class="box-white">
        <div class="wrapper padding-all">
            <div class="row">
                <div class="col-md-9 col-sm-12">
                    <div class="box-gray">
                        <div class="section-header">
                            <h2 class="letter-spacing">अहवाल</h2>
                            <h5>आपल्या संस्थेचा सन या सहकारी वर्षांचा अहवाल आपणासमोर सादर करीत आहोत. संचालक मंडळाच्या वतीने ३१ मार्च रोजी संपलेल्या सहकारी वर्षांचा अहवाल व ह्या सहकारी वर्षांत संस्थेने केलेल्या कामकाजाची माहिती ह्या सांकेतिक स्थळावर मार्फत
                                आपणासमोर सादर करतांना आनंद होत आहे.</h5>
                        </div>
                    </div>
                    <div class="table-responsive ">
                        <table id="example1 " class="table table-bordered table-striped ">
                            <thead>

                                <tr>
                                    <th>S.N.<i class="fa fa-sort pull-right "></i></th>
                                    <th>Annual Report</th>
                                    <!-- <th>Status</th> -->
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let user of data;  let i=index">
                                    <td>{{i+1}}</td>
                                    <td>
                                        {{user.nmpk_staffName}}
                                    </td>
                                    <td>
                                        <a href="https://nmpksbank.in/apis/{{user.nmpk_staffPhoto}}" target="_blank">Download File</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="space "></div>
                </div>
                <div class="col-md-3 col-sm-12 ">
                    <app-side-menu></app-side-menu>
                </div>
            </div>
        </div>
    </div>
    <!-- Section Content End -->

</section>
<!-- Services End -->